import axios from 'axios'
import store from '../../store'
// Define base url
const BASE_URL = '/api/v1/users'

// Define users module
const users = {
  state: {
    data: {},
    errors: null
  },
  getters: {
    usersCollection: state => {
      return state.data
    }
  },
  mutations: {
    getUsersData (state, payload) {
      state.data = payload
    },
    setUsersErrors (state, payload) {
      state.errors = payload
    },
    deleteUserData (state, payload) {
      const index = state.data.findIndex(i => i.id === payload)
      state.data.splice(index, 1)
    }
  },
  actions: {
    async usersGetData ({ commit }) {
      try {
        const response = await axios.get(BASE_URL)
        if (response.status === 200) {
          commit('getUsersData', response.data.data)
        }
      } catch (error) {
        commit('setUsersErrors', error)
      }
    },
    async usersStore ({ commit }, payload) {
      try {
        const response = await axios.post(BASE_URL, payload)
        if (response.status === 201) {
          return response.data.data
        }
      } catch (error) {
        commit('setUsersErrors', error.response.data.errors)
      }
    },
    async usersUpdate ({ commit }, payload) {
      try {
        const response = await axios.put(`${BASE_URL}/${payload.id}`, payload.data)
        if (response.status === 202) {
          return response.data
        }
      } catch (error) {
        commit('setUsersErrors', error)
        return error.response.data
      }
    },
    async usersDestroy ({ commit }, payload) {
      try {
        const response = await axios.delete(`${BASE_URL}/${payload}`, payload)
        if (response.status === 204) {
          commit('deleteUserData', payload)
        } else {
          return response
        }
      } catch (error) {
        commit('setUsersErrors', error)
      }
    }
  }
}

// Export the users module
export default users
